import React, { Suspense, lazy } from 'react';
import './App.css';
import ShinyShowcase from './ShinyShowcase';
import { Route, Routes, NavLink } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';

// Lazy load non-critical routes to reduce initial bundle size
const AdminPage = lazy(() => import('./AdminPage'));
const AdminLogPage = lazy(() => import('./AdminPanel').then(module => ({ default: module.AdminLogPage })));
const AboutPage = lazy(() => import('./AboutPage'));
const ShinyBoardPage = lazy(() => import('./ShinyBoardPage'));
const GuessTheHours = lazy(() => import('./GuessTheHours'));
const DexProgression = lazy(() => import('./DexProgression'));
const DrawingGame = lazy(() => import('./DrawingGame'));
const EggTimer = lazy(() => import('./EggTimer'));
const LoginPage = lazy(() => import('./LoginPage'));
const UserProfilePage = lazy(() => import('./UserProfilePage'));

function AppContent() {
  const { user, logout } = useAuth();

  return (
    <div className="app-shell">
      <nav className="navbar">
        <div className="navbar-inner">
          <div className="navbar-logo">
            <img
              src={process.env.PUBLIC_URL + "/flair/icon.png"}
              alt="Team Rädiance Logo"
              className="navbar-icon"
            />
            <div className="navbar-brand">
              Team <span>Rädiance</span>
            </div>
          </div>
          <ul className="navbar-links">
            <li><NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink></li>
            <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>About</NavLink></li>
            <li><NavLink to="/showcase" className={({ isActive }) => isActive ? 'active' : ''}>Shiny Showcase</NavLink></li>
            <li><NavLink to="/board" className={({ isActive }) => isActive ? 'active' : ''}>Shiny Board</NavLink></li>
            <li><NavLink to="/dex-progression" className={({ isActive }) => isActive ? 'active' : ''}>Dex Progression</NavLink></li>
            <li><NavLink to="/egg-timer" className={({ isActive }) => isActive ? 'active' : ''}>Egg Timer</NavLink></li>
            <li><NavLink to="/guess-hours" className={({ isActive }) => isActive ? 'active' : ''}>Guess the Hours</NavLink></li>
            {!user && <li><NavLink to="/login" className={({ isActive }) => isActive ? 'active' : ''}>Login</NavLink></li>}
            {user && <li><NavLink to={`/${user}`} className={({ isActive }) => isActive ? 'active' : ''}>{user}</NavLink></li>}
            {user && <li><button onClick={logout} style={{ background: 'none', border: 'none', color: 'inherit', font: 'inherit', cursor: 'pointer', padding: 0 }}>Logout</button></li>}
          </ul>
        </div>
      </nav>
        <main className="page-content">
          <Suspense fallback={<div style={{textAlign: 'center', padding: '2rem'}}>Loading...</div>}>
            <Routes>
              <Route path="/" element={<ShinyShowcase />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/showcase" element={<ShinyShowcase />} />
              <Route path="/board" element={<ShinyBoardPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/logs" element={<AdminLogPage />} />
              <Route path="/guess-hours" element={<GuessTheHours />} />
              <Route path="/dex-progression" element={<DexProgression />} />
              <Route path="/egg-timer" element={<EggTimer />} />
              <Route path="/skribmon" element={<DrawingGame />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/:username" element={<UserProfilePage />} />
            </Routes>
          </Suspense>
        </main>
        <footer
          className="site-footer"
          title={
            'This website and its creators have no connection with or endorsement from PokeMMO or its developers.\n' +
            'All Pokémon characters, and images are the intellectual property of Pokémon USA, Inc. and Nintendo. This website and its creators are not affiliated with or endorsed by Nintendo LLC, Creatures, GameFreak Inc., The Pokémon Company, Pokémon USA, Inc. or The Pokémon Company International.'
          }
        >
          © 2025 <strong>Team Radiance</strong>. All rights reserved.
        </footer>
      </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
